import { Edit } from "@mui/icons-material";
import { Typography, Stack, Tooltip, IconButton, Grid } from "@mui/material";
import moment from "moment";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { getEditorTrackingFieldNames } from "../helpers/schemas/getEditorTrackingFields";
dayjs.extend(relativeTime);
moment().format();
const editTrackingDates = ["Modified Date", "Created Date"];

export default function FeatureFields({
  feature,
  schema,
  onEditClick,
  TableName,
  allowUpdate = false,
}) {
  const theme = useTheme();
  const isSmallScreenUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <div>
      <Stack
        style={{ paddingBottom: 12 }}
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <Tooltip title={`Edit ${TableName}`}>
          <IconButton
            onClick={onEditClick}
            aria-label={`Edit ${TableName}`}
            size="large"
            color="primary"
            disabled={!allowUpdate}
          >
            <Edit fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Stack>

      {feature && feature.hasOwnProperty("map") && (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={feature.map}
            alt={feature.map}
            style={{
              width: "100%",
              // maxHeight: "150px",
              // paddingRight: 30,
              maxWidth: "800px",
              height: "auto",
              display:
                "block" /* Optional: Removes extra space below the image */,
              objectFit: "contain",
            }}
          />
        </Stack>
      )}

      {schema.map((att, idx) =>
        att.name !== "id" &&
        att.name !== "project_id" &&
        att.name !== "deleted" &&
        getEditorTrackingFieldNames().includes(att.name) === false &&       
        att.name !== "map" &&
        att.name !== "uid" &&
        att.name !== "placeId" &&
        att.name !== "latlon" &&
        att.name !== "equipment_id" &&
        att.name !== "checklist_id" &&
        !att.name.includes("pic_") &&
        att.name !== "observation_id" ? (
          <div key={idx} style={{ paddingTop: 10 }}>
            <Typography color="primary.light" variant="subtitle1" gutterBottom>
              {att.name}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              {feature.hasOwnProperty(att.name) &&
              feature[att.name] !== undefined &&
              feature[att.name].hasOwnProperty("seconds") &&
              editTrackingDates.includes(att.name)
                ? `${new Date(
                    feature[att.name].seconds * 1000,
                  ).toLocaleDateString()} ${new Date(
                    feature[att.name].seconds * 1000,
                  ).toLocaleTimeString()}`
                : feature[att.name] !== undefined &&
                    feature[att.name].hasOwnProperty("seconds")
                  ? `${new Date(
                      feature[att.name].seconds * 1000,
                    ).toLocaleDateString()}`
                  : feature[att.name]}
            </Typography>
          </div>
        ) : null,
      )}

      {feature && feature.hasOwnProperty("Created Date") && isSmallScreenUp ? (
        <div style={{ paddingTop: 10 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="caption"
                  gutterBottom
                  color="primary"
                >{`Created By:`}</Typography>
                <Typography
                  style={{ marginLeft: 4 }}
                  variant="caption"
                  gutterBottom
                >
                  {feature["Created By"]}
                </Typography>

                <Typography
                  variant="caption"
                  gutterBottom
                  color="primary"
                >{`Created Date:`}</Typography>
                <Typography
                  style={{ marginLeft: 4 }}
                  variant="caption"
                  gutterBottom
                >
                  {`${new Date(
                    feature["Created Date"].seconds * 1000,
                  ).toLocaleDateString()}
              
                 (${dayjs(
                   new Date(feature["Created Date"].seconds * 1000),
                 ).fromNow()})`}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="caption"
                  gutterBottom
                  color="primary"
                >{`Modified By:`}</Typography>
                <Typography
                  style={{ marginLeft: 4 }}
                  variant="caption"
                  gutterBottom
                >
                  {feature["Modified By"]}
                </Typography>

                <Typography
                  variant="caption"
                  gutterBottom
                  color="primary"
                >{`Modified Date:`}</Typography>
                <Typography
                  style={{ marginLeft: 4 }}
                  variant="caption"
                  gutterBottom
                >
                  {`${new Date(
                    feature["Modified Date"].seconds * 1000,
                  ).toLocaleDateString()}  (${dayjs(
                    new Date(feature["Modified Date"].seconds * 1000),
                  ).fromNow()})`}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </div>
      ) : feature && feature.hasOwnProperty("Created Date") ? (
        <div style={{ paddingTop: 10 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="caption"
                gutterBottom
                color="primary"
              >{`Created By:`}</Typography>
              <Typography
                style={{ marginLeft: 4 }}
                variant="caption"
                gutterBottom
              >
                {feature["Created By"]}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="caption"
                gutterBottom
                color="primary"
              >{`Created Date:`}</Typography>
              <Typography
                style={{ marginLeft: 4 }}
                variant="caption"
                gutterBottom
              >
                {`${new Date(
                  feature["Created Date"].seconds * 1000,
                ).toLocaleDateString()}
              
                 (${dayjs(
                   new Date(feature["Created Date"].seconds * 1000),
                 ).fromNow()})`}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="caption"
                gutterBottom
                color="primary"
              >{`Modified By:`}</Typography>
              <Typography
                style={{ marginLeft: 4 }}
                variant="caption"
                gutterBottom
              >
                {feature["Modified By"]}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="caption"
                gutterBottom
                color="primary"
              >{`Modified Date:`}</Typography>
              <Typography
                style={{ marginLeft: 4 }}
                variant="caption"
                gutterBottom
              >
                {`${new Date(
                  feature["Modified Date"].seconds * 1000,
                ).toLocaleDateString()}  (${dayjs(
                  new Date(feature["Modified Date"].seconds * 1000),
                ).fromNow()})`}
              </Typography>
            </Grid>
          </Grid>
        </div>
      ) : null}
    </div>
  );
}
